import { ConfigProviderProps } from 'antd'

export const configProviderTheme: ConfigProviderProps['theme'] = {
    components: {
        Input: { borderRadius: 0 },
        InputNumber: { borderRadius: 0 },
        Select: { borderRadius: 0 },
    },
}
